// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3d06a","title":"AfterFrontImage_title__-mfFa"};